import React from 'react'


import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import BlogClassicData from '../data/blog/BlogClassic3.json';
import BlogDetailsContainer from '../container/BlogGrid/BlogDetailsContainer';
import CallToAction from '../container/CallToAction/CallToAction';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import PrivacyPolicyContainer from '../container/BlogGrid/PrivacyPolicyContainer.js';
import SEO from '../components/SEO.jsx';

const Policies = () => {



    return (
        <React.Fragment>
            <SEO title="Do Not Sell My Personal Information" />
            <Header />
            <div className="section section-padding fix">
                <div className="container">
                    <div className="row mb-n10">

                        <div className="col-lg-12 col-12 order-lg-1 mb-10">
                            <div className="row row-cols-1 no-gutters">
                                <div className="blog-3 blog-details col" data-aos="fade-up">

                                    <div className="info">


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default Policies